import gymGamesBullPoster from "@/assets/eventos/gym-games-bull-2026.png";
import noticiaTcbTeamPoster from "@/assets/noticias/tt2.png";

const rankingParaibaPoster = "/poster-rankking.png";

export interface Noticia {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  date: string;
  category: string;
  author: string;
  featured: boolean;
  image?: string;
  fullContent?: string;
  instagramUrl?: string;
  instagramLabel?: string;
}

export const noticias: Noticia[] = [
  {
    id: 5,
    slug: "paraiba-conquista-titulo-seletiva-tcb",
    title: "PARAÍBA CONQUISTA TÍTULO EM SELETIVA TCB E SEGUE GANHANDO FORÇA NO CENÁRIO NACIONAL",
    excerpt: "Equipe 100% paraibana vence seletiva TCB e coloca João Pessoa entre os destaques do Functional Fitness brasileiro",
    date: "20 Mai 2026",
    category: "Atletas",
    author: "FPF3",
    featured: true,
    image: noticiaTcbTeamPoster,
    instagramUrl: "https://www.instagram.com/federacaopbf3/",
    instagramLabel: "@federacaopbf3",
    fullContent: `O Functional Fitness paraibano vive mais um momento histórico. Neste último fim de semana, uma equipe formada inteiramente por atletas da Paraíba conquistou o título de uma seletiva do TCB, uma das competições mais tradicionais e disputadas do país.

Representando João Pessoa, os atletas Diego Nascimento, Dalila Lucena, Karine Oliveira e Luan Vilar enfrentaram equipes da região Sudeste e também do Sul do Brasil, conquistando o lugar mais alto do pódio e entrando para a lista de paraibanos campeões de seletivas TCB.

Entre os destaques da equipe estão Diego Nascimento e Dalila Lucena, atletas já classificados para representar a Paraíba no Campeonato Brasileiro de Functional Fitness 2026, que acontecerá entre os dias 26 e 28 de junho, no Maracanãzinho | Ginásio Gilberto Cardoso, no Rio de Janeiro.

A conquista reforça o crescimento do esporte no estado e consolida uma geração de atletas que vem acumulando resultados importantes no cenário nacional.

## Histórico de títulos paraibanos em seletivas TCB

A vitória da equipe de João Pessoa amplia uma trajetória que já vem sendo construída por outros nomes do estado nos últimos anos.

Karine Oliveira já havia conquistado anteriormente uma seletiva TCB ao lado de atletas do estado de Pernambuco, consolidando mais uma vez seu nome entre os grandes resultados da modalidade.

Outro grande destaque é <a href="https://www.instagram.com/raquelzinha_lins/" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline font-semibold">Raquel Lins</a>, da @_cfcristo, campeã da seletiva de Aracaju em 2023 e também vencedora da seletiva de Recife em 2024, acumulando títulos importantes dentro do circuito.

Em 2024, o atleta <a href="https://www.instagram.com/crossboxpb/" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline font-semibold">Wellington Batista</a> também colocou a Paraíba no topo ao conquistar o título da seletiva realizada em Recife.

## Um legado que inspira novos atletas

Mais do que medalhas e classificações, os resultados representam a construção da história do Functional Fitness paraibano dentro do cenário nacional.

Cada conquista abre espaço para que novos atletas do estado possam acreditar que também é possível competir em alto nível, representar a Paraíba e disputar espaço entre os melhores do país.

Os títulos conquistados nessas seletivas certamente ficarão marcados na trajetória desses atletas e ajudam a fortalecer ainda mais o crescimento do esporte no estado.

Parabéns aos campeões paraibanos por mais um capítulo importante na história do Functional Fitness da Paraíba.`,
  },
  {
    id: 4,
    slug: "paraiba-destaque-functional-fitness-nacional",
    title: "PARAÍBA EM DESTAQUE NO FUNCTIONAL FITNESS NACIONAL",
    excerpt: "Campinenses dominam o NOXDURANCE e chegam fortes para representar a Paraíba no Campeonato Brasileiro de Functional Fitness",
    date: "20 Mai 2026",
    category: "Atletas",
    author: "FPF3",
    featured: false,
    image: "/cp1.png",
    instagramUrl: "https://www.instagram.com/federacaopbf3/",
    instagramLabel: "@federacaopbf3",
    fullContent: `O último fim de semana foi de destaque para a Paraíba no cenário nacional do Functional Fitness. Os atletas campinenses Pedro Albino e Asafe Alves, já classificados para o Campeonato Brasileiro de Functional Fitness 2026, mostraram mais uma vez por que chegam como os principais representantes do estado na competição nacional.

A dupla conquistou uma impressionante dobradinha no NOXDURANCE, competição realizada fora da Paraíba e que reuniu grandes nomes da modalidade na categoria RX (Avançados).

Pedro Albino confirmou o favoritismo e ficou com o título da competição após uma campanha dominante. O atleta encerrou o campeonato com apenas 17 pontos, enquanto o segundo e o terceiro colocados finalizaram com 23 pontos, evidenciando a consistência e o controle de Pedro ao longo de todas as provas.

A disputa pelo topo ainda contou com mais um paraibano em evidência. Asafe Alves garantiu o segundo lugar geral da competição e chegou na última prova já ocupando a vice-liderança. Pedro entrou no evento final com uma vantagem de apenas três pontos sobre Asafe, consolidando uma disputa de alto nível entre os dois atletas campinenses.

O resultado reforça o crescimento do Functional Fitness paraibano e aumenta a expectativa para o Campeonato Brasileiro, onde Pedro Albino e Asafe Alves terão a missão de representar a Paraíba entre os melhores atletas do país.

## Destaques da competição

* 🥇 Pedro Albino — Campeão RX
* 🥈 Asafe Alves — Vice-campeão RX
* 📍 Dobradinha paraibana no pódio
* 🇧🇷 Ambos classificados para o Campeonato Brasileiro de Functional Fitness 2026

Com grandes resultados fora do estado, a Paraíba segue consolidando sua força no cenário competitivo nacional do Functional Fitness.`,
  },
  {
    id: 3,
    slug: "fpf3-futuro-functional-fitness-categorias-faixa-etaria",
    title: "FPF3 projeta futuro do Functional Fitness na Paraíba com categorias por faixa etária",
    excerpt: "Federação pretende desenvolver categorias de base e ampliar o acesso ao esporte com foco em formação esportiva, segurança e desenvolvimento juvenil.",
    date: "07 Mai 2026",
    category: "Desenvolvimento Esportivo",
    author: "FPF3",
    featured: false,
    image: "/jovens-prog.png",
    fullContent: `A Federação Paraibana de Functional Fitness (FPF3) começa a discutir um dos projetos mais importantes para o futuro da modalidade no estado: o desenvolvimento de categorias por faixa etária e programas voltados para jovens atletas.

Inspirada nas diretrizes internacionais da iF3 para competições juvenis, a Federação entende que o crescimento sustentável do esporte passa diretamente pela formação esportiva desde a base.

A proposta busca criar um ambiente competitivo mais saudável, educativo e adaptado às necessidades de cada idade, respeitando o desenvolvimento físico, técnico e emocional dos atletas.

Entre os principais pilares discutidos estão:

📚 **Formação esportiva**
🛡️ **Segurança competitiva**
🏋️ **Desenvolvimento técnico progressivo**
🧠 **Qualidade de movimento**
🤝 **Participação familiar e educacional**

O objetivo da Federação não é apenas formar atletas competitivos, mas contribuir para a construção de hábitos saudáveis, disciplina, inclusão social e desenvolvimento humano através do esporte.

As futuras categorias deverão seguir modelos progressivos, respeitando a evolução de cada faixa etária e criando oportunidades para que novos atletas possam ingressar no Functional Fitness de maneira segura e estruturada.

**O esporte cresce quando existe base.**
**E a construção do futuro do Functional Fitness na Paraíba começa agora.**

—
FPF3 — Federação Paraibana de Functional Fitness`,
  },
  {
    id: 2,
    slug: "ranking-paraiba-2026-lideres-etapa-2",
    title: "Ranking Paraíba 2026: FPF3 divulga líderes das categorias após etapas iniciais",
    excerpt: "Com duas etapas concluídas, federação consolida sistema de pontuação e prepara anúncio de competição decisiva para a temporada.",
    date: "05 Mai 2026",
    category: "Rankings",
    author: "FPF3",
    featured: true,
    image: rankingParaibaPoster || gymGamesBullPoster,
    instagramUrl: "https://www.instagram.com/p/DX93kCtFAuJ/",
    instagramLabel: "@fpf3oficial",
    fullContent: `Após um início de temporada intenso e de alto nível técnico, a Federação Paraibana de Functional Fitness (FPF3) atualizou oficialmente o Ranking Paraíba 2026. Com o encerramento das duas primeiras etapas, o cenário competitivo começa a ganhar contornos definidos, revelando os atletas que despontam na liderança de cada categoria.

O desempenho apresentado até aqui é o reflexo direto da dedicação e constância dos praticantes de functional fitness em todo o estado. Mais do que números, o ranking simboliza a evolução do esporte na Paraíba e a consolidação de um sistema sólido de valorização do atleta.

**Transparência e Acesso**
O ranking completo, com a pontuação detalhada de todos os participantes, já está disponível para consulta no site oficial da Federação (fpf3.com.br). A plataforma permite que atletas e boxes acompanhem em tempo real suas posições e planejem as próximas estratégias para as etapas vindouras.

**O Que Vem por Aí**
A FPF3 alerta que a tranquilidade dos líderes pode estar com os dias contados. Em breve, será anunciada a próxima competição do calendário, que terá um peso estratégico fundamental. Este evento será decisivo para o fechamento do Ranking Paraíba, podendo alterar significativamente as posições no topo da tabela.

"Seguimos construindo um sistema sólido, valorizando cada atleta e cada etapa do processo", destaca a direção da FPF3 em nota oficial.

Para acompanhar os destaques, fotos e bastidores de cada etapa, a federação convida todos a visitarem o perfil oficial no Instagram (@fpf3oficial).`,
  },
  {
    id: 1,
    slug: "gym-games-bull-2026",
    title: "🔥 GYM GAMES BULL 2026",
    excerpt: "A Federação Paraibana de Functional Fitness (FPF3) apoia e divulga mais um grande evento que integra o calendário esportivo estadual. No dia 28 de fevereiro de 2026, o Box CF Bull será palco desta competição épica.",
    date: "01 Fev 2026",
    category: "Eventos",
    author: "FPF3",
    featured: false,
    image: gymGamesBullPoster,
    instagramUrl: "https://www.instagram.com/cf.bull/",
    instagramLabel: "@cf.bull",
    fullContent: `No dia 28 de fevereiro de 2026, o Box CF Bull, localizado no bairro do Altiplano, em João Pessoa, será palco do Gym Games Bull 2026 — uma competição de 1 dia, com foco total em ginástica e condicionamento, utilizando movimentos tradicionais do Funcional Fitness.

🏋️‍♂️ SOBRE A COMPETIÇÃO
O evento será composto por uma prova única, com duração de até 25 minutos, desafiando os atletas em: Força, Técnica, Resistência e Controle corporal sob fadiga. Um verdadeiro teste das habilidades ginásticas aplicadas ao condicionamento físico.

🤸 CLÍNICA DE GINÁSTICA — 21 de fevereiro de 2026
Antes da competição, os atletas poderão participar de uma Clínica de Ginástica, voltada ao aprimoramento técnico dos movimentos que serão explorados durante a prova oficial.

⚡ DESAFIO EXTRA – ESPECIALIDADES (Opcional)
Além da prova principal, os inscritos poderão optar pelo Desafio de Especialidades, composto por provas rápidas de 1 minuto, focadas em habilidades específicas e alto nível técnico.

📝 INSCRIÇÕES
As inscrições já estão abertas. Os interessados devem acessar a página oficial do evento para garantir sua vaga e conferir todas as informações.

🐂🔥 Prepare-se para competir, evoluir e viver a experiência Bull.
Quem é Bull, aguenta.`,
  },
];
export const categories = ["Todas", "Eventos", "Atletas", "Boxes", "Educação", "Rankings", "Desenvolvimento Esportivo"];

export function getNoticiaBySlug(slug: string): Noticia | undefined {
  return noticias.find((n) => n.slug === slug);
}
